import { render, staticRenderFns } from "./RiskLegenda.vue?vue&type=template&id=e3e62f60&scoped=true&"
import script from "./RiskLegenda.vue?vue&type=script&lang=js&"
export * from "./RiskLegenda.vue?vue&type=script&lang=js&"
import style0 from "./RiskLegenda.vue?vue&type=style&index=0&id=e3e62f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e62f60",
  null
  
)

export default component.exports